import { action, observable } from 'mobx';
import { api, sidApi } from '../config';
import { routingStore } from '../../index';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  enrollment: {
    ipAddress: '127.0.0.1' // Temporarily hard code IP because API requires it
  },
  links: {},
  sids: {},
  enrollmentSid: null,
  // Add enrollment data
  updateEnrollment: action(function(value, name){
    if(name === 'dob') {
      // If it’s the date of birth, we need to split it into month and day
      let dobArr = value.split('/');
      obx.enrollment.birthDay = parseInt(dobArr[0], 10);
      obx.enrollment.birthMonth = parseInt(dobArr[1], 10);
    } else {
      // Otherwise, just add the data to the enrollment object
      obx.enrollment[name] = value;
    }
  }),
  // Create user in SmarterID
  createSIDUser: action(function(){
    SessionStore.startLoading('Loading…', 'CreateSIDUser');

    const data = {
      externalId: SessionStore.userData.userSid,
      firstName: SessionStore.profile.firstName,
      lastName: SessionStore.profile.lastName,
      email: SessionStore.profile.email,
      mobilePhone: SessionStore.profile.mobilePhone,
      latitude: SessionStore.profile.latitude,
      longitude: SessionStore.profile.longitude,
      address: SessionStore.profile.address
    }

    // Remove empty data values because the API won’t accept them
    Object.keys(data).forEach(function(key, i) {
      if(!data[key]) {
        delete data[key]
      }
    })

    // Send the API call
    sidApi.post(`/installs/${SessionStore.userData.smarterIdInstallSid}/users`, data)
      .then(response => {
        obx.updateSIDSid(response.data.sid);
        SessionStore.finishLoading('CreateSIDUser');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Add SmarterID user id to profile data
  updateSIDSid: action(function(smarterId){
    SessionStore.startLoading('Loading…', 'UpdateSIDSid');

    const data = {...SessionStore.profile};

    // Remove disallowed or empty values
    Object.keys(data).forEach(function(key, i) {
      if(
        !data[key] ||
        (
          key !== 'address' &&
          key !== 'currencyCode' &&
          key !== 'homePhone' &&
          key !== 'latitude' &&
          key !== 'longitude' &&
          key !== 'maxTravelDistance' &&
          key !== 'maxTravelDistanceUnits' &&
          key !== 'mobilePhone' &&
          key !== 'smarterId' &&
          key !== 'timeZoneSid'
        )
      ) {
        delete data[key]
      }
    });

    data.smarterId = smarterId;

    api.put(`/installs/${SessionStore.userData.installSid}/users/${SessionStore.userData.userSid}/profile`, data)
      .then(response => {
        SessionStore.profile = response.data;
        obx.checkSIDEnrollment(data.smarterId.userSid);
        SessionStore.finishLoading('UpdateSIDSid');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Check if SmarterID enrollment exists and redirect if not
  checkSIDEnrollment: action(function(sid){
    SessionStore.startLoading('Loading…', 'CheckSIDEnrollment');

    let userSid = SessionStore.profile.smarterId.userSid;

    if(sid) {
      userSid = sid;
    }

    sidApi.get(`/installs/${SessionStore.userData.smarterIdInstallSid}/users/${userSid}/enrollments`)
      .then(response => {
        let activeEnrollment = false;

        // Loop through results to see if any enrollments are active
        for(let i = 0; i < response.data.results.length; i++) {
          if(response.data.results[i].status.toLowerCase() === 'active') {
            activeEnrollment = true;
          }
        }

        if((response.data.results.length === 0 || !activeEnrollment) && SessionStore.settings.smarterIdEnabled) {
          routingStore.push({
            pathname: '/enroll',
          });
        }

        SessionStore.finishLoading('CheckSIDEnrollment');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Create enrollment in SmarterID
  createSIDEnrollment: action(function(callback){
    SessionStore.startLoading('Loading…', 'CreateSIDEnrollment');

    sidApi.post(`/installs/${SessionStore.userData.smarterIdInstallSid}/users/${SessionStore.profile.smarterId.userSid}/enrollments`, obx.enrollment)
      .then(response => {
        obx.links = response.data;
        obx.enrollmentSid = response.data.sid;

        if(callback) {
          callback();
        }

        SessionStore.finishLoading('CreateSIDEnrollment');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get sids by tiny id
  getSids: action(function(tinyId){
    SessionStore.startLoading('Loading…', 'GetSids');

    sidApi.get(`/tiny/${tinyId}`)
      .then(response => {
        obx.sids = response.data;
        SessionStore.finishLoading('GetSids');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Add images
  uploadSIDImage: action(function(file, type, callback, component){
    SessionStore.startLoading('Loading…', 'UploadSIDImage');

    let formData = new FormData();

    formData.append('type', type);

    formData.append('image', file, `${obx.enrollmentSid}-${type}.jpg`);

    sidApi.put(`/installs/${SessionStore.userData.smarterIdInstallSid}/enrollments/${obx.enrollmentSid}/images`, formData)
      .then(response => {
        if(callback) {
          callback();
        }

        SessionStore.finishLoading('UploadSIDImage');
      })
      .catch(error => {
        console.error(error);

        // Determine which image errored so we can alert the user of it
        // and remove the selected image so they have to choose a new one
        let imgDescription = null;
        let imgName = null;

        switch (type) {
          case 'id-front':
            imgDescription = 'front of ID'
            imgName = 'idFront';
            break;

          case 'id-back':
            imgDescription = 'back of ID'
            imgName = 'idBack';
            break;

          case 'selfie':
            imgDescription = 'headshot'
            imgName = 'headshot';
            break;

          default:
            imgDescription = 'photo'

        }

        const imgError = {
          response: {
            data: {
              message: `Sorry, there was an error uploading your ${imgDescription}. Please try again.`
            }
          }
        }

        if(component) {
          // Remove the errored ID from the list of accepted photos
          let acceptedPhotos = [...component.state.acceptedPhotos];
          let index = acceptedPhotos.indexOf(imgName);
          acceptedPhotos.splice(index, 1);

          // Remove the selected photos and set the state
          component.setState({
            [imgName]: null,
            acceptedPhotos
          });
        }

        SessionStore.throwError(imgError);
      })
  }),
  // Get Images
  getSIDPhotos: action(function(component){
    sidApi.get(`/installs/${SessionStore.userData.smarterIdInstallSid}/enrollments/${obx.enrollmentSid}/images`)
      .then(response => {
        if(component) {
          let photoCount = 0;

          if(response.data.frontPhoto) {
            photoCount++;
          }

          if(response.data.backPhoto) {
            photoCount++;
          }

          if(response.data.selfiePhoto) {
            photoCount++;
          }

          component.setState({
            photoCount
          });
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get Enrollment
  getSIDEnrollment: action(function(){
    sidApi.get(`/installs/${SessionStore.userData.smarterIdInstallSid}/users/${SessionStore.profile.smarterId.userSid}/enrollments/${obx.enrollmentSid}`)
      .then(response => {
        obx.enrollment = response.data;
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Validate enrollment
  validationPassed: false,
  validationFailed: false,
  validationError: null,
  validateEnrollment: action(function(callback){
    obx.validationFailed = false;
    obx.validationError = null;

    sidApi.get(`/installs/${SessionStore.userData.smarterIdInstallSid}/enrollments/${obx.enrollmentSid}/validate`)
      .then(response => {
        // If confirm.io validation is still pending, wait 3 seconds then send again
        // to trigger the facial recognition
        if(response.data.status.toLowerCase() === 'pending') {
          setTimeout(function(){
            obx.validateEnrollment(callback);
          }, 3000);
        } else if(response.data.status.toLowerCase() === 'pass') {
          obx.validationPassed = true;

          if(callback) {
            callback();
          }
        }
      })
      .catch(error => {
        obx.validationFailed = true;
        obx.validationError = error.response.data.code;

        if(error.response.data.code === '1213' || error.response.data.code === '1210') {
          // confirm.io validation failed
        } else if(error.response.data.code === '1214') {
          // Facial match failed
        } else {
          SessionStore.throwError(error);
        }
      })
  }),

  /**
   * authenticateUser
   * @param {object} sids
   * @param {object} data
   * @param {function} errorCallback
   */
  authenticateUser: action((sids, data, errorCallback, successCallback) => {
    SessionStore.startLoading('authenticateUser');

    const { installSid, userSid } = sids;

    let formData = new FormData();

    formData.append('ipAddress', '127.0.0.1');
    formData.append('image', data.photo);

    sidApi.post(`/installs/${installSid}/users/${userSid}/authentication`, formData)
      .then(() => {
        SessionStore.finishLoading('authenticateUser');

        if(successCallback) {
          successCallback();
        }
      })
      .catch(error => {
        if(errorCallback) {
          errorCallback();

          SessionStore.finishLoading('authenticateUser');
        }

        if(error.response.data.code !== '1210') {
          SessionStore.throwError(error);
        }
      });
  })
});

export default obx;


// WEBPACK FOOTER //
// ./src/app/stores/SmarterIDStore.js